export var toggleAccordionEvent = 'toggle-accordion';
//# sourceMappingURL=constants.js.map